export default __webpack_public_path__ + "static/media/Web_09-01.b7121c23.png";